import { EntityType } from '@frontend/common';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { UserClient } from '@frontend/user/api';
import { IUser } from '@frontend/user/types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { AdminObjectBadge } from '../../../components/admin-object-badge/admin-object-badge.component';

interface Props {
    filter: string;
}
export const UserSearch = (props: Props) => {
    const {
        store: { currentAccount }
    } = useAccountRepository();
    const [results, changeResults] = useState<IUser[]>([]);

    useEffect(() => {
        if (props.filter !== '')
            UserClient.fetchUsers({ account_id: currentAccount, search: props.filter }).then((result) => {
                changeResults(result.results);
            });
    }, [props.filter, currentAccount]);

    if (results.length === 0) return null;
    return (
        <div className='mb-3 p-1'>
            <span className='border-border-default flex flex-row items-center justify-between border-b-1 pb-1'>
                <div className='ml-1 font-bold'>{CommonMessage.OBJECTS.USER.PLURAL}</div>
                <Link
                    className='mx-1 text-sm font-medium underline'
                    to='/users'>
                    {CommonMessage.BUTTONS.SHOW_ALL}
                </Link>
            </span>
            <div className='flex flex-col'>
                {results.map((result) => (
                    <AdminObjectBadge
                        entityType={EntityType.USER}
                        id={result.id}
                    />
                ))}
            </div>
        </div>
    );
};
